import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import { CaretIcon, Link } from '@tkww/the-bash-frontend';
import jump from 'helpers/jump';
import { styled } from '@mui/material/styles';

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  height: 80,
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  textAlign: 'center',
  paddingBottom: 4,
  backgroundColor: `${theme.palette.grey['700']}99`,
  color: theme.palette.dark.text,
  width: 164,
  [theme.breakpoints.up('md')]: {
    width: 255,
  },
  '&:hover': {
    backgroundColor: `${theme.palette.grey['700']}4D`,
    textDecoration: 'none',
    color: theme.palette.dark.text,
  },
  '&:active': {
    backgroundColor: `${theme.palette.grey['700']}4D`,
    textDecoration: 'none',
    color: theme.palette.dark.text,
  },
  '& svg': {
    width: 11,
  },
}));

const MarketTile = ({ market, marketImage }) => (
  <Grid item xs={6} md={6} lg={3} key={market.fileName} sx={{ borderRadius: '3px' }}>
    <Box
      data-testid="marketPaper"
      sx={{
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
        borderRadius: '3px',
        position: 'relative',
        background: `url(${marketImage}) no-repeat center`,
      }}
    >
      <StyledLink
        onClick={() => jump(`#${market.fileName}`)}
        path={`#${market.fileName}`}
        data-testid="marketLink"
      >
        {market.displayName}
        <CaretIcon direction="bottom" htmlColor="white" doubleCaret />
      </StyledLink>
    </Box>
  </Grid>
);

MarketTile.propTypes = {
  market: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
  }).isRequired,
  marketImage: PropTypes.string.isRequired,
};

export default MarketTile;
